import { render, staticRenderFns } from "./CompletedCoursesModal.vue?vue&type=template&id=3858ad60&"
import script from "./CompletedCoursesModal.vue?vue&type=script&lang=js&"
export * from "./CompletedCoursesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports